export const localStorageKeys = {
  authToken: 'authToken',
  account: 'account'
};